// import { consolidateStreamedStyles } from "styled-components";

const YEARS = 25;
const eachYear = (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const eachMonth = (Array.apply(null, { length: YEARS * 12 }).map(Number.call, Number)).map(x => (x + 1));
const lastMonthOfYear = (x, index) => (((index - 1) % 12) === 11);
const round2 = x => (parseFloat(x).toFixed(2));
const nonNegative = x => (x > 0 ? x : 0);

const seriesFutureHousePrice = ({ housePrice, futureHousePricePct}) => {
  const result = [ housePrice ];
  eachYear.forEach(year => {
    const prev = parseInt(result[result.length - 1]);
    const value = nonNegative(prev + (prev * (futureHousePricePct / 100)));
    result.push(value);
  });
  return result.map(round2);
};

const seriesNoRepayment = ({ loanTaken, interestTaken, adHocDrawdown, showDrawdown, adHocEnabled, drawdownValue1, drawdownYear1, drawdownValue2, drawdownYear2 , drawdownValue3, drawdownYear3}) => {
  const monthlyResult = [ parseInt(loanTaken, 10) ];

  eachYear.forEach(month => {
    const prev = parseFloat(monthlyResult[monthlyResult.length - 1]);
    let value = nonNegative(prev + (prev * (interestTaken / 100)));

    if(adHocDrawdown[month] > 0 && showDrawdown && adHocEnabled)
    {
      value = nonNegative(prev + parseInt(adHocDrawdown[month]) + (prev * (interestTaken / 100)));
    }
    else
    {
      if(month === drawdownYear1 && showDrawdown === true && drawdownValue1 > 0)
      {
        value = nonNegative(prev + parseInt(drawdownValue1) + (prev * (interestTaken / 100)));
      }

      if(month === drawdownYear2 && showDrawdown === true && drawdownValue2 > 0)
      {
        value = nonNegative(prev + parseInt(drawdownValue2) + (prev * (interestTaken / 100)));
      }

      if(month === drawdownYear3 && showDrawdown === true && drawdownValue3 > 0)
      {
        value = nonNegative(prev + parseInt(drawdownValue3) + (prev * (interestTaken / 100)));
      }
    }

    monthlyResult.push(value);
  });

  return monthlyResult.map(round2);
};

const series = ({ loanTaken, interestTaken, period, monthlyPayment, stopRepayment, showDrawdown, drawdownYear1, drawdownValue1, drawdownYear2, drawdownValue2, drawdownYear3, drawdownValue3, interestEnabled, maxEnabled, adHocEnabled = false, adHocPayments = {}, adHocDrawdown = {} }, title) => {
  const monthlyResult = [ parseInt(loanTaken, 10) ];

  let drawdownYear = [
    drawdownYear1,
    drawdownYear2,
    drawdownYear3
  ];

  let drawdownValue = [
    drawdownValue1,
    drawdownValue2,
    drawdownValue3
  ];

  let yearArray = [];

  if(stopRepayment.constructor === Array)
  {
    stopRepayment.forEach((years, index) => {
      for(let i = 0; i < years; i++)
      {
        yearArray.push({amount: monthlyPayment[index], max: maxEnabled[index], interest: interestEnabled[index]});
      }
    });
  }

  eachYear.forEach(month => {
    const prev = parseFloat(monthlyResult[monthlyResult.length - 1]);

    let value = 0;

    let currentDrawdownValue = 0;

    if(month === drawdownYear[0] && showDrawdown === true && drawdownValue[0] > 0)
    {
      currentDrawdownValue = drawdownValue[0];
    }

    if(month === drawdownYear[1] && showDrawdown === true && drawdownValue[1] > 0)
    {
      currentDrawdownValue = drawdownValue[1];
    }

    if(month === drawdownYear[2] && showDrawdown === true && drawdownValue[2] > 0)
    {
      currentDrawdownValue = drawdownValue[2];
    }

    if(adHocEnabled && showDrawdown)
    {
      currentDrawdownValue = parseInt(adHocDrawdown[month]);
    }

    if(stopRepayment.constructor === Array && adHocEnabled === false)
    {
      if(yearArray[month - 1] !== undefined)
      {
        if(yearArray[month - 1].max)
        {
          value = nonNegative(((prev - (prev * 0.1) + parseInt(currentDrawdownValue)) + ((prev - (prev * 0.1)) * (interestTaken / 100))));
        }
        else if(yearArray[month - 1].interest)
        {
          value = nonNegative(((prev + parseInt(currentDrawdownValue))));
        }
        else
        {
          value = nonNegative(((prev - yearArray[month - 1].amount + parseInt(currentDrawdownValue)) + ((prev - yearArray[month - 1].amount) * (interestTaken / 100))));
        }
      }

      if(month > yearArray.length)
      {
        value = nonNegative(((prev + parseInt(currentDrawdownValue)) + ((prev) * (interestTaken / 100))));
      }
    }
    else
    {
      value = nonNegative(((prev - monthlyPayment + parseInt(currentDrawdownValue)) + ((prev - monthlyPayment) * (interestTaken / 100))));

      if(month > stopRepayment)
      {
        value = nonNegative(((prev + parseInt(currentDrawdownValue)) + ((prev) * (interestTaken / 100))));
      }

      if(adHocEnabled)
      {
        value = nonNegative(((prev - parseInt(adHocPayments[month]) + parseInt(currentDrawdownValue)) + ((prev) * (interestTaken / 100))));
      }
    }

    monthlyResult.push(value);
  });

  return monthlyResult.map(round2);

  // if (title) {console.table(debug);}
  return [ loanTaken ].concat(monthlyResult.map(round2).filter(lastMonthOfYear));
};

const stopAfterZero = arr => {
  const zeroIndex = arr.findIndex(x => (x <= 0));
  return (zeroIndex !== -1) ? arr.slice(0, zeroIndex + 1) : arr;
};

const equityRetained = (index, futureHousePrice, noRepayments) => {
  return round2(futureHousePrice[index] - noRepayments[index]);
}

const futureTableCalc = (futureHousePrice, noRepayments, partialRepayment) => {
  return [
    {
      title: "Today",
      propertyValue: futureHousePrice[0],
      amountOwed: noRepayments[0],
      equity: equityRetained(0, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[0],
      equityPartialRepayments: futureHousePrice[0] - partialRepayment[0],
    },
    {
      title: "5 years",
      propertyValue: futureHousePrice[5],
      amountOwed: noRepayments[5],
      equity: equityRetained(5, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[5],
      equityPartialRepayments: futureHousePrice[5] - partialRepayment[5],
    },
    {
      title: "10 years",
      propertyValue: futureHousePrice[10],
      amountOwed: noRepayments[10],
      equity: equityRetained(10, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[10],
      equityPartialRepayments: futureHousePrice[10] - partialRepayment[10],
    },
    {
      title: "15 years",
      propertyValue: futureHousePrice[15],
      amountOwed: noRepayments[15],
      equity: equityRetained(15, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[15],
      equityPartialRepayments: futureHousePrice[15] - partialRepayment[15],
    },
    {
      title: "20 years",
      propertyValue: futureHousePrice[20],
      amountOwed: noRepayments[20],
      equity: equityRetained(20, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[20],
      equityPartialRepayments: futureHousePrice[20] - partialRepayment[20],
    },
    {
      title: "25+ years",
      propertyValue: futureHousePrice[25],
      amountOwed: noRepayments[25],
      equity: equityRetained(25, futureHousePrice, noRepayments),
      amountOwedPartialRepayments: partialRepayment[25],
      equityPartialRepayments: futureHousePrice[25] - partialRepayment[25],
    }
  ];
}

export const partialRepaymentOutput = (input) => {
  const { loanTaken, interestTaken, capitalValue1, capitalValue2, capitalValue3, showRepayments, showNoRepayments, showDrawdown } = input;
  const monthlyInterestRepayment = parseFloat((loanTaken * (interestTaken * 0.01) / 12).toFixed(2));
  const futureHousePrice = seriesFutureHousePrice(input);
  const cappedWithHp = (arr) => arr.map((x, index) => ((parseFloat(x, 10) > parseFloat(futureHousePrice[index], 10)) ? futureHousePrice[index] : x));
  const noRepayments = cappedWithHp(seriesNoRepayment(input));

  const payingOffInterest = cappedWithHp(series({ ...input, stopRepayment: input.stopPayingOffInterest, monthlyPayment: monthlyInterestRepayment, showDrawdown: showDrawdown }, "payingOffInterest" ));
  const partialRepayment = cappedWithHp(stopAfterZero(series({ ...input, stopRepayment: [input.stopPartialRepayment1, input.stopPartialRepayment2, input.stopPartialRepayment3], monthlyPayment: [capitalValue1, capitalValue2, capitalValue3], showDrawdown: showDrawdown, maxEnabled: [input.max1, input.max2, input.max3], interestEnabled: [input.interest1, input.interest2, input.interest3], adHocEnabled: input.adHocEnabled, adHocDrawdown: input.adHocDrawdown, adHocPayments: input.adHocPayments })));
  const maxStopAfter = partialRepayment.findIndex(x => (x <= 0));
  const tableData = futureTableCalc(futureHousePrice, noRepayments, partialRepayment);
  return {
    monthlyInterestRepayment,
    maxStopAfter,
    series: {
      futureHousePrice,
      noRepayments,
      payingOffInterest,
      partialRepayment,
      tableData,
      showRepayments,
      showNoRepayments,
      showDrawdown
    },
  };
};



// WEBPACK FOOTER //
// ./src/services/PartialRepaymentCalc.js